export enum CncAdsWebType {
  MOBILE = 'mobile',
  DEKSTOP = 'dekstop',
  RESPONSIVE = 'responsive',
}